export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_athletic-hub-172/artifacts/3pfgc591_ChatGPT%20Image%20Jul%2029%2C%202026%2C%2010_08_33%20AM.png";

export default function Logo({ size = 36, showText = true, textClass = "" }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <img src={LOGO_URL} alt="SphereHyx" style={{ height: size, width: size }} className="rounded-lg object-cover" />
      {showText && (
        <span className={`font-heading font-extrabold tracking-tight text-[1.15rem] ${textClass}`}>
          Sphere<span className="brand-gradient-text">Hyx</span>
        </span>
      )}
    </div>
  );
}
